/* global WorldWind */

// Tampere
const sector = new WorldWind.Sector(59.950, 62.626, 21.448, 26.180);
// App
//const sector = WorldWind.Sector.FULL_SPHERE;

export default sector;
